import React from 'react';
import '../../styles/components/SuggestionChip.css';

interface SuggestionChipProps {
  label: string;
  isSelected: boolean;
  onClick: () => void;
  isWorkshopItem?: boolean;
  tooltip?: string;
}

/**
 * A clickable chip for selecting suggested options in forms
 */
const SuggestionChip: React.FC<SuggestionChipProps> = ({ 
  label, 
  isSelected, 
  onClick,
  isWorkshopItem = false,
  tooltip
}) => {
  return (
    <div 
      className={`suggestion-chip ${isSelected ? 'selected' : ''} ${isWorkshopItem ? 'workshop-item' : ''}`}
      onClick={onClick}
      title={tooltip || label}
    >
      {label}
      {isWorkshopItem && <span className="workshop-indicator"></span>}
    </div>
  );
};

export default SuggestionChip; 